import styled from 'styled-components';

import { ModalBody, Input, Button } from 'reactstrap';
import { color } from '../../../assets/styles/colors';

export const Title = styled.h1`
	background-color: #D3FBE1;
	font-size: 18px;
	font-weight: bold;
	padding: 0 0 11px 4vw;
	margin: 0;
	overflow: auto;
	border-bottom: 1px solid black;
`;

export const ModalBodyCss = styled(ModalBody)`
	align-items: center;
	justify-content: space-between;
	padding: 30px 4vw 40px 4vw;
`;

export const ModalFooterCss = styled.div`
	background-color: #D3FBE1;
	border-top: 1px solid black;
	text-align: right;
	width: 100%;
	overflow: auto;
	padding: 0px 4vw 0 0;

	@media (max-width: 768px) {
		text-align: center;
    	padding: 0 0 0 0;
  	}
`;

export const ButtonCss = styled(Button)`
	font-size: 14px;
	min-height: 30px;
	font-weight: 500;
	background-color: ${color.yellow};
`;

export const InputDescriptionCss = styled(Input)`
	min-height: 280px;
	font-size: 16px;
	font-weight: 300;
	line-height: 160%;

	@media (max-width: 768px) {
    	min-height: 100px;
  	}
`;

export const InputCss = styled(Input)`
	border: 0.5px solid #ced4da;
	font-size: 16px;
	font-weight: 300;
	line-height: 160%;
`;

export const ButtonAdd = styled(Button)`
	width: 100%;
	font-size: 16px;
	min-height: 30px;
	font-weight: 300;

	border-radius: 0px;
	background-color: '#FFFFFF';
	border: 0.5px solid #000000;
`;

export const TextStatus = styled.h5`
	font-weight: bold;
	margin: 0;
	font-size: 24px;
	line-height: 160%;
`;
